import {PlatformMessageType} from "../platform-message-type.enum";

export enum BonusAbuseBetRejectReasonEnum {
    Sport = 1,
    Poker = 2,
    PokerAndSport = 3
}

export interface BetRejectedRawData {
    PlatformMessagesType: PlatformMessageType.BET_REJECTED,
    RejectionReasonId: BonusAbuseBetRejectReasonEnum;
    GameTypeID: number;
    RealMoneyBalance: number;
    BetCurrencyCode: string;
}
